import { Component } from '@angular/core';
import { ProspectData } from '@lsq-frontend/remote-services/ar-app';
import moment from 'moment';
import { IActivityField, IActivityProspectFields } from './prospect-activity.interface';
import { DrApplicationService } from '@lsqlabs/dr-application-shared';
import { DateFormat } from '../../admin-prospects.component';

@Component({
    selector: 'prospect-activity',
    styleUrls: ['./prospect-activity.component.scss'],
    templateUrl: './prospect-activity.component.html'
})
export class ManageProspectActivityComponent {
    public prospect: ProspectData = { ...this._arService.getProspect() };
    public activityProspectFields: IActivityProspectFields[] = this.buildActivityProspect();
    constructor(private _arService: DrApplicationService) {}

    public buildActivityProspect(): IActivityProspectFields[] {
        const fields = Object.keys(activityFieldsMap);
        const activityProspectFields: IActivityProspectFields[] = [];
        fields.forEach((field: string) => {
            activityProspectFields.push({
                label: activityFieldsMap[field],
                fieldValue: this.checkFieldValue(activityFieldsMap[field], this.prospect[field])
            });
        });
        return activityProspectFields;
    }

    public isDate(date: string): boolean {
        return moment(date, true).isValid();
    }

    public checkFieldValue(label: string, value: string): string {
        if (this.isDate(value)) {
            const dateValue = moment(value);
            const result: string = dateValue.format(DateFormat);
            if (label === activityFieldsMap.submittedDate) {
                const createdDate = moment(this.prospect.createdDate);
                return dateValue.isBefore(createdDate) ? '--' : result;
            }
            return result;
        }
        return value || '--';
    }
}

export const activityFieldsMap: IActivityField = {
    createdDate: 'DATE CREATED',
    source: 'SOURCE',
    coordinatorUserId: 'INVITED BY',
    updatedDate: 'LATEST ACTIVITY',
    submittedDate: 'DATE SUBMITTED',
    status: 'STATUS'
};
